import { render, staticRenderFns } from "./strategyCustomerList.vue?vue&type=template&id=1ff1d9bc"
import script from "./strategyCustomerList.vue?vue&type=script&lang=js"
export * from "./strategyCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports